// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-15cf09bc] .invoice-print-body-tr td{font-size:10px !important;padding:0px !important;padding-left:4px !important;padding-right:4px !important}[data-v-15cf09bc] .invoice-print-head-tr th{font-size:12px !important;padding:0px !important;padding-left:4px !important;padding-right:4px !important}", ""]);
// Exports
module.exports = exports;
